module.exports = __webpack_public_path__ + "assets/webgl/art_050_L0.jpg.49519f92.webp";